import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'SearchPipe'
})
export class SearchPipe implements PipeTransform {
  transform(items: Array<any>, attribute: string, term: string): Array<any> {
    if (!term || term === '') { return items; }

    const attributeArray = attribute.split(',').map(attr => attr.trim());
    
    return items.filter((item) => {
      return attributeArray.some(attribute => {
        const attributeValue = item[attribute];
        const stringValue = attributeValue !== undefined ? attributeValue.toString() : null;
        return stringValue && stringValue.toLowerCase().includes(term.toLowerCase());
      });
    });
  }
}
